<!-- <mat-checkbox class="m-10 checkbox" [(ngModel)]="showLocalSimon" (change)="openSimonSso()">Local Simon
    </mat-checkbox> -->
<div *ngIf="environment.qa" class="absolute top-0 right-0 p-10 px-20 m-10 rounded-full shadow-lg bg-gray-lighter" @fadeIn>
    <mat-slide-toggle [(ngModel)]="showLocalSimon" (change)="openSimonSso()">Local Simon</mat-slide-toggle>
</div>
<iframe class="w-full h-full min-h-720" [appIframeData] [src]="iframeUrl | safeUrl" @fadeIn></iframe>